import { useTranslation } from 'react-i18next';
import Form from 'react-bootstrap/Form';

function EmployeeForm({ employeeIdMode, consumer, formErrors, handleChange, renderError }) {
  const { t } = useTranslation();

  if (employeeIdMode === 'hide') {
    return null;
  }

  return (
    <Form.Group className="mb-3">
      <Form.Control
        className={formErrors && formErrors.employeeId ? 'bo-input bo-input-error' : 'bo-input'}
        type="text"
        name="employeeId"
        id="employeeId"
        placeholder={
          consumer.tokenType !== 'prospect'
            ? t('pages.signup_details_second.employee_form.employee_id_placeholder')
            : ''
        }
        value={consumer.employeeId ? consumer.employeeId : ''}
        noValidate
        onChange={e => handleChange(e)}
        disabled={consumer.tokenType === 'prospect'}
      />
      {'employeeId' in formErrors ? renderError(formErrors.employeeId) : ''}
    </Form.Group>
  );
}

export default EmployeeForm;
